var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Tab, Tabs, TextField, Typography, } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useFetcher, useResetter, useResource } from 'rest-hooks';
import AdminMediaResource from '../../../api/AdminMediaResource';
import grey from '@material-ui/core/colors/grey';
import red from '@material-ui/core/colors/red';
import DeleteIcon from '@material-ui/icons/Delete';
import { toast } from "react-hot-toast";
//@ts-ignore
import pdfIcon from '../assets/pdfIcon.svg';
//@ts-ignore
import { Document, Page, pdfjs } from 'react-pdf';
import { MenuItem } from '@wordpress/components';
import { useGlue } from '../../..';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
const { FormFileUpload } = require('@wordpress/components');
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        height: '100%',
    },
    icon: {
        color: 'rgba(255, 255, 255, 0.54)',
    },
    paper: {
        width: '100%',
        height: '100%',
        display: 'grid',
        padding: '0px',
        overflowY: 'hidden',
        gridTemplateColumns: '1fr 300px',
    },
    grid: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        alignContent: 'flex-start',
        overflowY: 'auto',
        padding: '20px',
        boxSizing: 'border-box',
    },
    tile: {
        width: '150px',
        height: '150px',
        margin: '5px',
        backgroundColor: grey[300],
    },
    selected: {
        border: '2px solid ' + theme.palette.primary.main,
        margin: '-2px -2px',
    },
    mediaHandler: {
        width: '100%',
        height: '100%',
        maxHeight: '100%',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: grey[300],
        boxShadow: '-5px 0px 7px 0px rgba(0,0,0,0.3)',
        padding: '30px 10px',
        boxSizing: 'border-box',
    },
    preview: {
        width: '100%',
    },
    gridImg: {
        objectFit: 'contain',
        height: '100%',
        width: '100%',
    },
    gridIcon: {
        objectFit: 'contain',
        height: '80%',
        width: '100%',
    },
    fileName: {
        color: 'black',
        fontSize: '12px',
        textAlign: 'center',
    },
    bar: {
        fontSize: '24px',
        boxShadow: '0px 5px 9px -2px rgba(0,0,0,0.45)',
    },
    title: {
        flexGrow: 1,
    },
    buttonContainer: {
        flexGrow: 1,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
    },
    selectButton: {
        fontWeight: 'bold',
    },
    deleteButton: {
        fontWeight: 'bold',
        backgroundColor: red[500],
        padding: '8px 0px',
        color: '#FFFFFF',
    },
    textField: {
        width: '100%',
        margin: '10px 0px',
    },
    addRow: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: '10px',
        paddingBottom: '10px',
        width: '100%',
        borderBottom: '1px solid ' + grey[300],
        height: '52px',
        alignItems: 'center',
    },
    message: {
        width: '100%',
    },
    tabs: {
        flexGrow: 2,
    },
}));
class MediaBrowserState {
    constructor(state, setState) {
        this.state = state;
        this.setState = setState;
    }
    updateState(state) {
        this.setState(new MediaBrowserState(state, this.setState));
    }
}
const MediaBrowserContext = React.createContext(new MediaBrowserState({ uploading: false, selectedMedia: null }, () => {
}));
function UploadButton({ onChange, tab }) {
    let accept = '*/*', text = 'Charger un fichier';
    switch (tab) {
        case 'image':
            accept = 'image/*';
            text = 'Charger une image';
            break;
        case 'pdf':
            accept = 'application/x-pdf';
            text = 'Charger un pdf';
    }
    return React.createElement(FormFileUpload, { accept: accept, onChange: onChange, multiple: true },
        React.createElement(Button, null, text));
}
function MediaElement({ media, classes, onClick }) {
    var _a;
    const context = useContext(MediaBrowserContext);
    const selected = media.id === ((_a = context.state.selectedMedia) === null || _a === void 0 ? void 0 : _a.id);
    const viewer = useMemo(() => {
        var _a, _b;
        if (!media.type) {
            return React.createElement(CircularProgress, null);
        }
        if (media.type['type'] === 'image') {
            return React.createElement("img", { className: classes.gridImg, src: '/api/media/' + media.id, alt: "" });
        }
        if (media.type['type'] === 'application' && media.type['subtype'] === 'pdf') {
            return React.createElement(React.Fragment, null,
                React.createElement("img", { className: classes.gridIcon, src: pdfIcon, alt: "PDF Resource" }),
                React.createElement("div", { className: classes.fileName }, (_a = media.meta) === null || _a === void 0 ? void 0 : _a.name));
        }
        return React.createElement(React.Fragment, null,
            React.createElement("div", { className: classes.fileName }, (_b = media.meta) === null || _b === void 0 ? void 0 : _b.name));
    }, [media.meta, media.type]);
    return React.createElement("div", { className: selected ? (classes.selected + ' ' + classes.tile) : classes.tile, onClick: onClick }, viewer);
}
const MediaSideBar = ({ selectMode, updateMeta, saveMedia, deleteMedia, }) => {
    var _a, _b, _c;
    const context = useContext(MediaBrowserContext);
    const classes = useStyles();
    const media = context.state.selectedMedia;
    const [deleteDialogOpened, setDeleteDialogOpen] = useState(false);
    const cancelDelete = useCallback(() => {
        setDeleteDialogOpen(false);
    }, [setDeleteDialogOpen]);
    const confirmDelete = useCallback(() => {
        if (media)
            deleteMedia(media);
        setDeleteDialogOpen(false);
    }, [deleteMedia, media, setDeleteDialogOpen]);
    if (media === null) {
        return React.createElement(React.Fragment, null);
    }
    let form = React.createElement(React.Fragment, null);
    let preview = React.createElement(React.Fragment, null);
    if (media.type['type'] === 'application' && media.type['subtype'] === 'pdf') {
        preview = React.createElement(Document, { file: '/api/media/' + media.id },
            React.createElement(Page, { pageNumber: 1, width: "280" }));
        form = React.createElement(React.Fragment, null,
            React.createElement(TextField, { id: "namefield", className: classes.textField, label: "Titre", variant: "outlined", value: (_a = media.meta) === null || _a === void 0 ? void 0 : _a.name, onChange: (event) => updateMeta({
                    name: event.target.value,
                }) }));
    }
    if (media.type['type'] === 'image') {
        preview = React.createElement("img", { className: classes.gridImg, src: '/api/media/' + media.id, alt: "" });
        form = React.createElement(React.Fragment, null,
            React.createElement(TextField, { id: "altfield", className: classes.textField, label: "Alt", variant: "outlined", value: (_b = media.meta) === null || _b === void 0 ? void 0 : _b.alt, onChange: (event) => updateMeta({
                    alt: event.target.value,
                }) }),
            React.createElement(TextField, { id: "namefield", className: classes.textField, label: "Titre", variant: "outlined", value: (_c = media.meta) === null || _c === void 0 ? void 0 : _c.name, onChange: (event) => updateMeta({
                    name: event.target.value,
                }) }));
    }
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.preview }, preview),
        form,
        React.createElement("div", { className: classes.buttonContainer },
            React.createElement(Button, { className: classes.deleteButton, variant: 'contained', disabled: media.id === '', onClick: () => {
                    setDeleteDialogOpen(true);
                } },
                React.createElement(DeleteIcon, null)),
            React.createElement(Button, { className: classes.selectButton, color: "primary", variant: 'contained', disabled: media.id === '', onClick: () => {
                    saveMedia(media);
                } }, selectMode ? 'Sélectionner' : 'Sauvegarder')),
        React.createElement(Dialog, { open: deleteDialogOpened, onClose: cancelDelete, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" },
            React.createElement(DialogTitle, { id: "alert-dialog-title" }, "\u00CAtes-vous s\u00FBr ?"),
            React.createElement(DialogContent, null,
                React.createElement(DialogContentText, { id: "alert-dialog-description" }, "Le fichier sera d\u00E9finitivement supprim\u00E9 et deviendra inaccessible dans les pages l'utilisant.")),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: cancelDelete, color: "primary" }, "Annuler"),
                React.createElement(Button, { onClick: confirmDelete, color: "primary", autoFocus: true }, "Confirmer"))));
};
export const MediaBrowser = ({ onMediaSelect }) => {
    const [uploading, setUploading] = useState(false);
    const [browserState, setBrowserState] = useState(null);
    useEffect(() => {
        if (browserState == null) {
            setBrowserState(new MediaBrowserState({
                uploading: false,
                selectedMedia: null,
            }, setBrowserState));
        }
    }, [browserState, setBrowserState]);
    const selected = browserState === null || browserState === void 0 ? void 0 : browserState.state.selectedMedia;
    const setSelected = useCallback((media) => {
        browserState === null || browserState === void 0 ? void 0 : browserState.updateState(Object.assign(Object.assign({}, browserState === null || browserState === void 0 ? void 0 : browserState.state), { selectedMedia: media }));
    }, [browserState]);
    const [search, setSearch] = useState('');
    const [sort, setSort] = useState('nameAsc');
    const classes = useStyles();
    const glue = useGlue();
    const [meta, setMeta] = useState([]);
    const [tab, setTab] = useState('image');
    const uploadMedia = useFetcher(AdminMediaResource.createShape());
    const deleteMedia = useFetcher(AdminMediaResource.delete());
    const resetCache = useResetter();
    const apiResource = useResource(AdminMediaResource.list(), {});
    const resource = useMemo(() => {
        apiResource.forEach((media) => {
            let index = meta.findIndex((element) => element['id'] === media['id']);
            if (index >= 0)
                media.meta = meta[index];
        });
        return [...apiResource];
    }, [apiResource, meta]);
    useEffect(() => {
        glue.api.get('/api/admin/mediameta/').then((response) => {
            if (response.status === 200) {
                setMeta(response.data);
            }
        });
    }, [glue.api, setMeta]);
    const handleTabChange = useCallback((tabName) => {
        setSelected(null);
        setTab(tabName);
    }, [setSelected, setTab]);
    const updateMeta = useCallback((id, name, alt) => {
        return glue.api.put('/api/admin/mediameta/name/' + id, name, { headers: { 'Content-Type': 'text/plain' } }).then(() => {
            let metaCopy = [...meta];
            if (metaCopy.findIndex(element => element['id'] === id) > 0) {
                metaCopy[metaCopy.findIndex(element => element['id'] === id)]['name'] = name;
                metaCopy[metaCopy.findIndex(element => element['id'] === id)]['alt'] = alt;
            }
            else {
                metaCopy.push({ id, name, alt });
            }
            setMeta(metaCopy);
        });
    }, [glue.api, meta, setMeta]);
    const updateSelected = useCallback((media) => {
        setSelected(media);
    }, [setSelected, meta]);
    const mediaUpload = useCallback((file) => __awaiter(void 0, void 0, void 0, function* () {
        setUploading(true);
        try {
            var data = new FormData();
            data.append('media', file);
            const media = yield uploadMedia({}, data);
            if (media.id && media.id !== '') {
                resource.push(media);
                setMeta([...meta,
                    {
                        id: media.id,
                        name: file.name,
                        alt: '',
                    }]);
            }
            resetCache();
            updateSelected(media);
            toast.success(file.name + " correctement importé");
        }
        catch (e) {
            toast.error("Erreur lors de l'upload de " + file.name);
        }
        setUploading(false);
    }), [uploadMedia, setUploading, setMeta, meta, resource, updateSelected, resetCache]);
    const handleDelete = useCallback((media) => __awaiter(void 0, void 0, void 0, function* () {
        setSelected(null);
        yield deleteMedia({ id: media.id }, undefined);
    }), [setSelected, deleteMedia]);
    const filteredRessource = useMemo(() => {
        let res = resource;
        res = res.filter((media) => {
            switch (tab) {
                case 'image':
                    return media.type['type'] === 'image';
                case 'pdf':
                    return media.type['type'] === 'application' && media.type['subtype'] === 'pdf';
                default:
                    return true;
            }
        });
        if (search.length > 0) {
            const filter = search.toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            res = resource.filter(e => e.name.toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').indexOf(filter) > -1);
        }
        return res.sort((a, b) => {
            switch (sort) {
                case 'nameAsc':
                    return a.name.localeCompare(b.name);
                case 'nameDesc':
                    return b.name.localeCompare(a.name);
                default:
                    return 0;
            }
        });
    }, [resource, search, sort, tab]);
    if (browserState == null) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(MediaBrowserContext.Provider, { value: browserState },
        React.createElement("div", { className: classes.paper },
            React.createElement("div", { className: classes.grid },
                React.createElement("div", { className: classes.addRow },
                    React.createElement(Tabs, { className: classes.tabs, value: tab, onChange: (e, val) => handleTabChange(val) },
                        React.createElement(Tab, { label: "Images", value: "image" }),
                        React.createElement(Tab, { label: "PDF", value: "pdf" })),
                    React.createElement(TextField, { label: "Recherche", value: search, onChange: (e) => setSearch(e.target.value) }),
                    React.createElement(TextField, { label: "Trier par", value: sort, onChange: (e) => setSort(e.target.value), select: true },
                        React.createElement(MenuItem, { value: 'nameAsc' }, "Nom (A-Z)"),
                        React.createElement(MenuItem, { value: 'nameDesc' }, "Nom (Z-A)")),
                    uploading ?
                        React.createElement(CircularProgress, { color: "primary" })
                        :
                            React.createElement(UploadButton, { tab: tab, onChange: (e) => __awaiter(void 0, void 0, void 0, function* () {
                                    const target = e.target;
                                    if (target && target.files && target.files.length > 0) {
                                        for (let i = 0; i < target.files.length; i++) {
                                            yield mediaUpload(target.files[i]);
                                        }
                                    }
                                }) })),
                filteredRessource.length <= 0 &&
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: classes.message },
                            React.createElement(Typography, { variant: "body1" }, "Aucun m\u00E9dia disponible"))),
                React.createElement(React.Fragment, null, filteredRessource.map((media) => React.createElement(MediaElement, { key: media.id, media: media, classes: classes, onClick: () => {
                        updateSelected(media);
                    } })))),
            React.createElement("div", { className: classes.mediaHandler },
                React.createElement(MediaSideBar, { selectMode: onMediaSelect !== undefined, updateMeta: (updatedMeta) => {
                        if (selected) {
                            selected.meta = Object.assign(Object.assign({}, selected.meta), updatedMeta);
                            setSelected(Object.assign({}, selected));
                        }
                    }, saveMedia: (media) => {
                        var _a, _b;
                        updateMeta(media.id, ((_a = media.meta) === null || _a === void 0 ? void 0 : _a.name) || '', ((_b = media.meta) === null || _b === void 0 ? void 0 : _b.alt) || '')
                            .then(() => {
                            if (onMediaSelect) {
                                onMediaSelect(media);
                            }
                            else {
                                setSelected(null);
                            }
                        });
                    }, deleteMedia: (media) => {
                        handleDelete(media);
                    } })))));
};
//# sourceMappingURL=index.js.map